
                  export default function (Component) {
                      Component.__source = "src/components/right/index.vue"
                  }
              